export const BUTTON_TEXTS = {
  SAVE_DRAFT: 'Save as draft',
  PREVIOUS_STEP: 'Previous step',
  NEXT_STEP: 'Next step',
  PUBLISH: 'Publish',
  ADD: 'Add content',
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
  DELETE: 'Delete content',
  EDIT: 'Edit',
  TRY_AGAIN: 'Try again',
  DISCARD_CHANGES: 'Discard changes',
  GO_TO_MY_OFFERINGS: 'Go to My Offerings',
  CLOSE: 'Close',
  BACK_TO_MY_OFFERINGS: 'Back to My Offerings',
  BACK_TO_OFFERING: 'Back to Offering',
  SAVE: 'Save changes',
  ADD_KNOWLEDGE: 'Add knowledge content',
  EDIT_KNOWLEDGE: 'Edit knowledge content',
  EDIT_OFFERING: 'Edit main content',
  MANAGE_CONTRIBUTORS: 'Manage contributors',
  ADDING_KNOWLEDGE: 'Adding knowledge content...',
  PUBLISHING: 'Publishing...',
  DRAFT_SAVING: 'Saving as draft...',
  UNPUBLISH: 'Unpublish',
  ADD_NEW_OFFERING: 'Add new offering',
  ADD_APPLICATION: 'Application',
  ADD_INFRASTRUCTURE: 'Infrastructure',
  ADD_PLATFORM: 'Platform',
  ADD_PROFESSIONAL_SERVICE: 'Professional service',
  GET_STARTED: 'Get started',
  JOIN_NOW: 'Join now',
  CLICK_HERE: 'Click here',
  VENDOR_ACTION: 'Visit Vendor’s website',
};
